import React, { useState } from 'react';
import styles from './AboutUs.module.css';

const AboutUs = () => {
  const [email, setEmail] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [submissionStatus, setSubmissionStatus] = useState('idle');

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setIsValidEmail(validateEmail(e.target.value));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateEmail(email)) {
      setSubmissionStatus('error');
      return;
    }

    try {
      setSubmissionStatus('loading');

      const response = await fetch('https://e-mobile-api-ituma2afya-oa.a.run.app/pre-register/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setSubmissionStatus('success');
      } else {
        setSubmissionStatus('error');
      }
    } catch (error) {
      console.error('Error submitting email:', error);
      setSubmissionStatus('error');
    }
  };

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  return (
    <section className={styles.AboutUs}>
      <h2 className={styles.title}>Free premium plans</h2>
      <div className={styles.spacer}></div>
      <form onSubmit={handleSubmit} className={styles.inputContainer}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={handleEmailChange}
          className={styles.input}
        />
        <button type="submit" className={styles.button}>
          Count me in
        </button>
        <div className={styles.comingSoon}>
          Coming this<br />summer
        </div>
      </form>

      <p className={styles.text}>
        {submissionStatus === 'idle' && 'Join the list to receive a free LIFETIME membership upon launch'}
        {submissionStatus === 'loading' && 'Submitting...'}
        {submissionStatus === 'success' && 'Thank you for subscribing!'}
        {submissionStatus === 'error' && 'Something went wrong. Please try again later.'}
      </p>
      <h3 className={styles.secondaryTitle}>for our first 1000 users</h3>
    </section>
  );
};

export default AboutUs;
